document.addEventListener('DOMContentLoaded', function () {
  const ugcSlider = document.getElementById('ugc-slider')
  if (ugcSlider) {
    // eslint-disable-next-line no-undef, no-unused-vars
    const ugcSwiper = new Swiper('#ugc-slider', {
      spaceBetween: 10,
      slidesPerView: 'auto',
      grabCursor: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      a11y: false,
      breakpoints: {
        320: {
          touchRatio: 1.5,
          slidesOffsetAfter: 60
        },
        1300: {
          slidesPerView: 3.25,
          touchRatio: 0,
          slidesOffsetAfter: 60,
          grabCursor: false
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        slideChange: function () {
          pauseAllVideos()
        }
      }
    })
  }

  function pauseAllVideos () {
    const videos = document.querySelectorAll('.swiper-slide video')
    videos.forEach((video) => {
      if (!video.paused) {
        video.pause()
      }
    })
  }

  const videos = document.querySelectorAll('.swiper-slide video')
  videos.forEach((video) => {
    video.addEventListener(
      'click',
      function (event) {
        video.play()
      },
      { once: true }
    )
    video.addEventListener('play', function () {
      videos.forEach((otherVideo) => {
        if (otherVideo !== video) {
          otherVideo.pause()
        }
      })
    })
  })
})
